import 'core-js/stable'
import Vue from 'vue'
import { provideApolloClient } from '@vue/apollo-composable'

import SuiIcons from '@siteminder/sui-icons'
import SuiCore from '@siteminder/sui-core'
import App from '@/App.vue'
import { router } from '@/router'
import store from '@/store'

import '@siteminder/sui-core/sui-core.esm.css'
import '@/tailwind.css'

import '@/setup/setup-analytics'
import '@/setup/setup-clipboard2'
import { i18n } from '@/setup/setup-i18n'
import { apolloClient } from '@/setup/apollo-clients'
import config from '@/config'

Vue.config.productionTip = false

Vue.use(SuiIcons)
Vue.use(SuiCore, { i18n })

new Vue({
  router,
  store,
  i18n,
  setup() {
    provideApolloClient(apolloClient)
  },
  render: h => h(App),
}).$mount('#app')
